import { DESKTOP_BREAKPOINT, isDesktopWidth } from '@/utils/desktopChrome';

export default {
  data() {
    return {
      viewportWidth: 0,
      desktopChromeReady: false,
    };
  },

  computed: {
    isDesktop() {
      return isDesktopWidth(this.viewportWidth);
    },
  },

  mounted() {
    this.syncViewportWidth();
    this.desktopChromeReady = true;
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.syncViewportWidth);
    }
  },

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.syncViewportWidth);
    }
  },

  methods: {
    syncViewportWidth() {
      this.viewportWidth =
        typeof window === 'undefined' ? 0 : window.innerWidth || DESKTOP_BREAKPOINT;
    },
  },
};
